export default __webpack_public_path__ + "static/media/pp-title-en.d286084b.webp";